import { useState } from "react"
import type { IPaginationParams } from "@/shared/api/search-params"
import { PAGER } from "@/shared/config/api.ts"

export function usePagination() {
  const [pager, setPager] = useState<Required<IPaginationParams>>(PAGER)

  const setPage = (page: number) => {
    setPager(prev => ({ ...prev, page }))
  }

  const setPerPage = (page_size: number) => {
    setPager(prev => ({ ...prev, page_size }))
  }

  return {
    pager,
    setPager,
    setPage,
    setPerPage
  }
}
